import campaignTitleExperiment, {
    useCampaignTitleExperiment,
} from '@shared/abtests/campaign-title';
import facebookDeprecation from './facebookDeprecation';
import crossCampaignExperiment, { isCrossCampaignVariant } from './cross-campaign';
import octopusKpiExperiment from './octopus-kpi';
import filterByFreshnessExperiment, { useFilterByFreshnessExperiment } from './filter-by-freshness';
import deliveryFlagExperiment, { useDeliveryFlagVariant } from './delivery-flag';
import showstopperExperiment, { useShowstopper } from './showstopper';
import showstopperRedesignExperiment, { useRedesignedShowstopper } from './showstopperRedesign';
import CCFNewImagesExperiment, { useCCFNewImages } from './ccf-new-images';
import ccfNewPositionExperiment, { useCCFNewPosition } from './ccf-new-position';
import smartBannerExperiment, { useSmartBanner } from './smart-banner';

export {
    isCrossCampaignVariant,
    useFilterByFreshnessExperiment,
    useDeliveryFlagVariant,
    useShowstopper,
    useCCFNewImages,
    useCCFNewPosition,
    useRedesignedShowstopper,
    useCampaignTitleExperiment,
    useSmartBanner,
};

export default {
    client: [],
    server: [
        facebookDeprecation,
        crossCampaignExperiment,
        octopusKpiExperiment,
        filterByFreshnessExperiment,
        deliveryFlagExperiment,
        showstopperExperiment,
        CCFNewImagesExperiment,
        ccfNewPositionExperiment,
        showstopperRedesignExperiment,
        campaignTitleExperiment,
        smartBannerExperiment,
    ],
};
